// extracted by mini-css-extract-plugin
export var title = "styles-module--title--2KJqM";
export var text = "styles-module--text--1fJ8D";